import {
  ApplicationConfig, inject, InjectionToken, PLATFORM_ID,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection
} from '@angular/core';
import {PreloadingStrategy, provideRouter, withInMemoryScrolling, withPreloading, withViewTransitions} from '@angular/router';

import {routes} from './app.routes';
import {provideClientHydration, withEventReplay} from '@angular/platform-browser';
import Aura from '@primeuix/themes/aura';
import {providePrimeNG} from 'primeng/config';
import {HttpClient, provideHttpClient, withFetch, withInterceptors} from '@angular/common/http';
import {prefixInterceptor} from './shared/interceptors/prefix-interceptor';
import * as http from 'node:http';
import {isPlatformBrowser, isPlatformServer} from '@angular/common';
import {catchError, of, switchMap, take, tap} from 'rxjs';
import {DialogService, DynamicDialogRef} from 'primeng/dynamicdialog';
import {ConfirmationService, MessageService} from 'primeng/api';
import {AuthService} from './shared/services/auth';
import {cookieForwardingInterceptor} from './shared/interceptors/cookie-interceptor';
import {NG_STATUS_CLASSES} from '@angular/forms/signals/compat';
import {provideLottieOptions} from 'ngx-lottie';
import {StorageService} from './shared/services/storage-service';
import {provideSignalFormsConfig} from '@angular/forms/signals';
import {NgEventBus} from 'ng-event-bus';
import {Lightbox, LightboxConfig, LightboxEvent, LightboxModule} from 'ngx-lightbox';
import {LightboxWindowRef} from 'ngx-lightbox/lightbox-event.service';
import {refreshSessionInterceptor} from './shared/interceptors/refresh-session.ts-interceptor';
import {provideShareButtonsOptions} from 'ngx-sharebuttons';
import {shareIcons} from 'ngx-sharebuttons/icons';

export const SSR_REQUEST = new InjectionToken<any>('SSR_REQUEST');

export function generateRandom64(): string {
  const chars =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const array = new Uint32Array(64);
  crypto.getRandomValues(array);

  return Array.from(array, x => chars[x % chars.length]).join('');
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideClientHydration(withEventReplay()),
    provideAppInitializer(() => {

      const http = inject(HttpClient);
      const authService = inject(AuthService);
      const storageService = inject(StorageService);
      const platformId = inject(PLATFORM_ID);
      // if (isPlatformServer(platformId)) return of(true);
      let sessionID = storageService.getItem('session');
      if (sessionID == null) storageService.setItem('session', generateRandom64());
      return http.get('csrf-cookie').pipe(
        switchMap(() => http.get('user/check', {})),
        tap((res: any) => authService.saveUser(res)),
        catchError(() => {
          authService.logout()
          return of(true);
        }),
        take(1)
      )
    }),
    provideShareButtonsOptions(
      shareIcons()
    ),
    provideSignalFormsConfig({classes: NG_STATUS_CLASSES}),
    provideBrowserGlobalErrorListeners(),
    provideHttpClient(withFetch(), withInterceptors([prefixInterceptor, refreshSessionInterceptor, cookieForwardingInterceptor])),
    provideRouter(routes, withViewTransitions(), withInMemoryScrolling({
      anchorScrolling: 'enabled',
      scrollPositionRestoration: 'enabled',
    })),
    NgEventBus,
    Lightbox,
    LightboxConfig,
    LightboxEvent,
    LightboxWindowRef,
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: '.d'
        }
      }
    }),
    provideLottieOptions({
      player: () => import('lottie-web'),
    }),
    DialogService,
    MessageService,
    DynamicDialogRef,
    ConfirmationService,
  ]
};
